import { render, staticRenderFns } from "./HistoryCard.vue?vue&type=template&id=094adfde&scoped=true"
import script from "./HistoryCard.vue?vue&type=script&lang=js"
export * from "./HistoryCard.vue?vue&type=script&lang=js"
import style0 from "./HistoryCard.vue?vue&type=style&index=0&id=094adfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094adfde",
  null
  
)

export default component.exports